import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { useState } from "react";
import { toast } from "react-toastify";
import APIS from "../../constant/Endpoint";
import useDeleteHook from "../../hooks/useDeleteHook";
import OverViewIcon from "../../icons/OverViewIcon copy";

const ComponentListComponent = loadable(
  () => import("../../components/Components/List"),
  {
    fallback: (() => {
      return <p>Loading</p>;
    })(),
  }
);

export default function ComponentsList() {
  const [showDeletModal, setShowDeleteModal] = useState(false);

  const { mutateAsync: deleteComponent, isLoading: isDeletingComponent } =
    useDeleteHook({
      queryKey: ["delete-component"],
    });

  const handleDelete = async (id: string) => {
    try {
      const url = `${APIS.COMPONENT}${id}/`;
      await deleteComponent({ url });
      setShowDeleteModal(false);
    } catch (error) {
      if (error instanceof Error) toast.error(error.message);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <OverViewIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Components</span>
      </div>
      <div>
        <ComponentListComponent
          showDeleteModal={showDeletModal}
          setShowDeleteModal={setShowDeleteModal}
          handleDelete={handleDelete}
          isDeletingComponent={isDeletingComponent}
        />
      </div>
    </>
  );
}
